module.exports = __webpack_public_path__ + "static/media/gertner-vinobrani-04.3715a597.png";